
export default {
	isHomeLoginValidate(state) {
		return state.userAccountStatus
	},
	historyAccount(state) {
		return state.userAccountList.filter(({ account_with_star }) => !!account_with_star)
	},
	canQuickLoginAccount(state) {
		const lastAccount = state.userAccountList[0]
		if (!lastAccount) return null
		const { login } = lastAccount
		return !login ? lastAccount : null
	}
}
